{
	"action": {
		"audit_retention_applied": "Conservazione applicata",
		"authz_denied": "Accesso rifiutato",
		"group_created": "Gruppo creato",
		"group_deleted": "Gruppo eliminato",
		"group_member_added": "Persona aggiunta a un gruppo",
		"group_member_removed": "Persona rimossa da un gruppo",
		"group_updated": "Gruppo modificato",
		"link_accessed": "Link aperto",
		"link_created": "Link creato",
		"link_downloaded": "Scaricato tramite link",
		"link_password_locked": "Link bloccato per password errate",
		"link_previewed": "Anteprima tramite link",
		"link_revoked": "Link revocato",
		"link_updated": "Link aggiornato",
		"link_upload_limited": "Link di caricamento al limite",
		"node_purged": "Eliminato definitivamente",
		"node_upload_reconciled": "Caricamento riconciliato",
		"node_version_deleted": "Versione eliminata",
		"node_versions_expired": "Versioni precedenti rimosse",
		"org_link_changed": "Accesso dell'organizzazione modificato",
		"org_link_opened": "Aperto tramite l'accesso dell'organizzazione",
		"organization_created": "Organizzazione creata",
		"organization_quota_changed": "Quota dell'organizzazione modificata",
		"organization_reactivated": "Organizzazione riattivata",
		"organization_storage_destroyed": "Spazio di archiviazione distrutto",
		"organization_suspended": "Organizzazione sospesa",
		"organization_version_retention_changed": "Conservazione delle versioni modificata",
		"policy_changed": "Politica modificata",
		"session_force_disconnected": "Disconnessa da un amministratore",
		"session_revoked": "Sessione terminata",
		"share_granted": "Condivisione concessa",
		"share_revoked": "Condivisione revocata",
		"share_role_changed": "Ruolo di condivisione modificato",
		"upload_expired": "Caricamento scaduto",
		"user_credentials_changed": "Credenziali modificate",
		"user_deactivated": "Accesso sospeso",
		"user_email_changed": "Indirizzo email modificato",
		"user_invite_accepted": "Invito accettato",
		"user_invite_resent": "Invito reinviato",
		"user_invited": "Persona invitata",
		"user_membership_removed": "Rimossa dall'organizzazione",
		"user_owner_granted": "Proprietario assegnato",
		"user_owner_revoked": "Proprietario rimosso",
		"user_quota_changed": "Quota modificata",
		"user_reactivated": "Accesso ripristinato",
		"user_removed": "Persona rimossa",
		"user_role_changed": "Ruolo modificato"
	},
	"actor": {
		"device": "Dispositivo di sincronizzazione",
		"link_recipient": "Visitatore di un link pubblico",
		"operator": "Operatore di piattaforma",
		"system": "Sistema",
		"unknown": "Persona non più presente",
		"unknown_hint": "Questa persona non fa più parte dell'organizzazione. Il registro di ciò che ha fatto resta."
	},
	"batch": {
		"failed_one": "{{count, number}} non riuscito",
		"failed_other": "{{count, number}} non riusciti"
	},
	"batch_kind": {
		"copy_one": "{{count, number}} file copiato",
		"copy_other": "{{count, number}} file copiati",
		"download_one": "{{count, number}} file scaricato",
		"download_other": "{{count, number}} file scaricati",
		"preview_one": "Anteprima di {{count, number}} file",
		"preview_other": "Anteprima di {{count, number}} file",
		"restore_one": "{{count, number}} elemento ripristinato dal cestino",
		"restore_other": "{{count, number}} elementi ripristinati dal cestino",
		"trash_one": "{{count, number}} elemento spostato nel cestino",
		"trash_other": "{{count, number}} elementi spostati nel cestino",
		"upload_one": "{{count, number}} file caricato",
		"upload_other": "{{count, number}} file caricati",
		"version_restore_one": "Versione precedente ripristinata su {{count, number}} file",
		"version_restore_other": "Versione precedente ripristinata su {{count, number}} file"
	},
	"batch_sentence": {
		"copy_one": "Ha copiato {{count, number}} file.",
		"copy_other": "Ha copiato {{count, number}} file.",
		"download_one": "Ha scaricato {{count, number}} file.",
		"download_other": "Ha scaricato {{count, number}} file.",
		"preview_one": "Ha aperto l'anteprima di {{count, number}} file.",
		"preview_other": "Ha aperto l'anteprima di {{count, number}} file.",
		"restore_one": "Ha ripristinato {{count, number}} file o cartella dal cestino.",
		"restore_other": "Ha ripristinato {{count, number}} file o cartelle dal cestino.",
		"trash_one": "Ha spostato {{count, number}} file o cartella nel cestino.",
		"trash_other": "Ha spostato {{count, number}} file o cartelle nel cestino.",
		"upload_one": "Ha caricato {{count, number}} file.",
		"upload_other": "Ha caricato {{count, number}} file.",
		"version_restore_one": "Ha ripristinato una versione precedente di {{count, number}} file.",
		"version_restore_other": "Ha ripristinato una versione precedente di {{count, number}} file."
	},
	"category": {
		"access": "Accessi",
		"content": "Contenuti",
		"organization": "Organizzazione",
		"people": "Persone",
		"sharing": "Condivisione"
	},
	"columns": {
		"actor": "Chi",
		"timestamp": "Quando",
		"what": "Cosa"
	},
	"detail": {
		"actor": "Chi",
		"bytes": "Dati trasferiti",
		"files_count_one": "{{count, number}} file",
		"files_count_other": "{{count, number}} file",
		"files_failed": "File non riusciti",
		"files_succeeded": "File riusciti",
		"metadata": "Dettagli",
		"object_id": "ID",
		"object_type": "Tipo",
		"origin": "Da dove",
		"outcome": "Esito",
		"section": {
			"event": "Evento",
			"object": "Oggetto",
			"transfer": "Trasferimento"
		},
		"timestamp": "Quando",
		"title": "Dettagli",
		"user_agent": "Client",
		"view_person_activity": "Tutta l'attività di questa persona"
	},
	"empty": {
		"beyond_retention_description_one": "Il periodo che hai chiesto è tutto più vecchio del {{count}} giorno che questa organizzazione conserva. Tutto quello che precede il {{date}} è stato rimosso: non è un periodo in cui non è successo niente.",
		"beyond_retention_description_other": "Il periodo che hai chiesto è tutto più vecchio dei {{count}} giorni che questa organizzazione conserva. Tutto quello che precede il {{date}} è stato rimosso: non è un periodo in cui non è successo niente.",
		"beyond_retention_title": "Questi eventi non ci sono più",
		"description": "Appena succede qualcosa nella tua organizzazione compare qui, dal più recente.",
		"no_matches_description": "Dentro la finestra di conservazione non c'è niente che corrisponda a questi filtri. Prova ad allargare il periodo o a togliere un filtro.",
		"no_matches_title": "Nessun risultato",
		"title": "Non è ancora stato registrato niente"
	},
	"filters": {
		"object": "Oggetto",
		"period": "Periodo",
		"period_default": "Ultimi 30 giorni",
		"person": "Persona",
		"person_placeholder": "Cerca una persona",
		"type": "Tipo"
	},
	"object_type": {
		"group": "Gruppo",
		"node": "File o cartella",
		"organization": "Organizzazione",
		"policy": "Politica",
		"user": "Persona"
	},
	"origin": {
		"api": "API",
		"system": "Sistema",
		"web": "Web"
	},
	"outcome": {
		"failure": "Non riuscito",
		"success": "Riuscito"
	},
	"page_title": "Audit",
	"quota": {
		"no_limit": "nessun limite"
	},
	"role": {
		"member": "Membro",
		"org_admin": "Amministratore"
	},
	"sentence": {
		"audit_retention_applied_one": "Ha applicato la conservazione, rimuovendo {{count}} evento.",
		"audit_retention_applied_other": "Ha applicato la conservazione, rimuovendo {{count}} eventi.",
		"authz_denied": "Ha eseguito un'operazione senza il permesso necessario.",
		"group_created": "Ha creato il gruppo <b>{{name}}</b>.",
		"group_deleted": "Ha eliminato il gruppo <b>{{name}}</b>.",
		"group_made_private": "Ha reso privato il gruppo <b>{{name}}</b>.",
		"group_made_public": "Ha reso pubblico il gruppo <b>{{name}}</b>.",
		"group_member_added": "Ha aggiunto una persona a un gruppo.",
		"group_member_removed": "Ha rimosso una persona da un gruppo.",
		"group_renamed": "Ha rinominato il gruppo <b>{{previousName}}</b> in <b>{{name}}</b>.",
		"link_accessed": "Ha aperto un link pubblico.",
		"link_created": "Ha creato un link pubblico su un file o una cartella.",
		"link_created_password_protected": "Ha creato un link pubblico protetto da password su un file o una cartella.",
		"link_downloaded": "Ha scaricato <b>{{name}}</b> tramite un link pubblico.",
		"link_password_locked": "Un link pubblico ha smesso di accettare password dopo troppi tentativi sbagliati.",
		"link_previewed": "Ha aperto l'anteprima di <b>{{name}}</b> tramite un link pubblico.",
		"link_revoked": "Ha revocato un link.",
		"link_updated": "Ha cambiato la scadenza di un link.",
		"link_upload_limited": "Un link di caricamento ha raggiunto il limite giornaliero e per ora non accetta altri file.",
		"node_purged": "Ha eliminato definitivamente un elemento e tutte le sue versioni.",
		"node_upload_reconciled": "Ha verificato un caricamento non confermato.",
		"node_version_deleted": "Ha eliminato la versione {{versionNumber}} di un file.",
		"node_versions_expired_one": "Ha rimosso {{count}} versione precedente che la conservazione delle versioni non tiene pi\u00f9.",
		"node_versions_expired_other": "Ha rimosso {{count}} versioni precedenti che la conservazione delle versioni non tiene pi\u00f9.",
		"org_link_closed": "Ha chiuso un file o una cartella all'organizzazione: mantengono l'accesso solo le persone aggiunte.",
		"org_link_opened_to": "Ha aperto un file o una cartella a chiunque nell'organizzazione con il link, come {{role}}.",
		"org_link_visited": "Ha aperto un file o una cartella tramite l'accesso dell'organizzazione.",
		"organization_created_failure": "Il provisioning dell'organizzazione non è riuscito.",
		"organization_created_success": "Il provisioning dell'organizzazione è stato completato.",
		"organization_quota_changed": "Ha cambiato la quota dell'organizzazione da {{previous}} a {{next}}.",
		"organization_reactivated": "Ha riattivato l'organizzazione.",
		"organization_storage_destroyed_one": "Ha distrutto lo spazio di archiviazione dell'organizzazione ({{count}} elemento).",
		"organization_storage_destroyed_other": "Ha distrutto lo spazio di archiviazione dell'organizzazione ({{count}} elementi).",
		"organization_suspended": "Ha sospeso l'organizzazione.",
		"organization_suspended_reason": "Ha sospeso l'organizzazione: {{reason}}.",
		"organization_version_retention_changed": "Ha cambiato quante versioni precedenti di ogni file vengono conservate, e per quanto tempo.",
		"policy_changed": "Ha modificato la policy <b>{{key}}</b>.",
		"session_force_disconnected": "Ha disconnesso <b>{{name}}</b>.",
		"session_revoked": "Ha terminato una sessione di <b>{{name}}</b>.",
		"share_granted": "Ha condiviso un file o una cartella con <b>{{subject}}</b> come {{role}}.",
		"share_granted_via_move": "Ha condiviso un file o una cartella con <b>{{subject}}</b> come {{role}}, tramite spostamento.",
		"share_revoked": "Ha revocato la condivisione di un file o una cartella a <b>{{subject}}</b>.",
		"share_revoked_via_move": "Ha revocato la condivisione di un file o una cartella a <b>{{subject}}</b>, tramite spostamento.",
		"share_role_changed": "Ha cambiato il ruolo di <b>{{subject}}</b> su un file o una cartella da {{previousRole}} a {{role}}.",
		"share_role_changed_via_move": "Ha cambiato il ruolo di <b>{{subject}}</b> su un file o una cartella da {{previousRole}} a {{role}}, tramite spostamento.",
		"upload_expired_one": "Il caricamento è scaduto dopo {{count}} minuto di inattività.",
		"upload_expired_other": "Il caricamento è scaduto dopo {{count}} minuti di inattività.",
		"user_credentials_changed": {
			"configure_otp": "Ha aggiunto un dispositivo per la verifica in due passaggi.",
			"other": "Ha modificato le proprie credenziali di accesso.",
			"regenerate_recovery_codes": "Ha generato nuovi codici di recupero.",
			"remove_otp_device": "Ha rimosso un dispositivo della verifica in due passaggi.",
			"update_password": "Ha cambiato la propria password."
		},
		"user_deactivated": "Ha sospeso l'accesso di <b>{{name}}</b>.",
		"user_deactivated_reason": "Ha sospeso l'accesso di <b>{{name}}</b>: {{reason}}.",
		"user_email_changed": "Ha corretto l'indirizzo email di <b>{{name}}</b> da {{previousEmail}} a {{newEmail}}.",
		"user_invite_accepted": "Ha accettato l'invito come {{role}}.",
		"user_invite_resent_one": "Ha reinviato l'invito a <b>{{name}}</b> (tentativo {{count}}).",
		"user_invite_resent_other": "Ha reinviato l'invito a <b>{{name}}</b> (tentativo {{count}}).",
		"user_invited": "Ha invitato <b>{{name}}</b> come {{role}}.",
		"user_membership_removed": "Ha rimosso <b>{{name}}</b> dall'organizzazione.",
		"user_owner_granted": "{{name}} è diventato proprietario dell'organizzazione per mano dell'operatore della piattaforma. Prima era {{previousRole}}.",
		"user_owner_revoked": "{{name}} non è più proprietario dell'organizzazione, per mano dell'operatore della piattaforma. Ne restano {{remaining}}.",
		"user_quota_changed": "Ha cambiato la quota di <b>{{name}}</b> da {{previous}} a {{next}}.",
		"user_reactivated": "Ha ripristinato l'accesso di <b>{{name}}</b>.",
		"user_removed": "Ha revocato l'invito di <b>{{name}}</b>.",
		"user_role_changed": "Ha cambiato il ruolo di <b>{{name}}</b> da {{previousRole}} a {{newRole}}."
	},
	"subject": {
		"group": "un gruppo"
	},
	"total_one": "{{count}} elemento",
	"total_other": "{{count}} elementi"
}
